import React, { useState } from 'react';
import { X } from 'lucide-react';
import { Link as RouterLink } from 'react-router-dom';
import Portal from './portal';
import { useTranslation } from 'react-i18next';
import './Photo.css';
function Photos() {
     const { t, i18n } = useTranslation();
      
          const changeLanguage = (e) => {
            i18n.changeLanguage(e.target.value);
        };
    const [selectedImage, setSelectedImage] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const imagePaths = {
        main: "/assets/Photo/1.jpeg",
        thumb1: "/assets/Photo/2.jpeg",
        thumb2: "/assets/Photo/3.jpeg",
        thumb3: "/assets/Photo/4.png"
    };

    const galleryImages = [
        { src: imagePaths.main, alt: "Main photo of Musée Loukach", isMain: true },
        { src: imagePaths.thumb1, alt: "Secondary photo 1 of Musée Loukach", isMain: false },
        { src: imagePaths.thumb2, alt: "Secondary photo 2 of Musée Loukach", isMain: false },
        { src: imagePaths.thumb3, alt: "Secondary photo 3 of Musée Loukach", isMain: false },
    ];
    const openModal = (imageSrc) => {
        setSelectedImage(imageSrc);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedImage(null);
    };

    React.useEffect(() => {
        const handleEscape = (event) => {
            if (event.key === 'Escape' && isModalOpen) {
                closeModal();
            }
        };
        window.addEventListener('keydown', handleEscape);
        return () => window.removeEventListener('keydown', handleEscape);
    }, [isModalOpen]);

    const mainImageClasses = "rounded-[34%_34%_3%_3%] shadow-lg shadow-[#FDD095]";
    const thumbnailClasses = "rounded-[50%_50%_4%_4%] shadow-lg shadow-[#FCB456]";

    return (
        <div id='Photos' data-aos="fade-up" className="mx-8 container mt-8 grid grid-cols-1 md:grid-cols-2 mx-auto px-4 gap-12 lg:gap-20 pb-10 " >
            <div className='mx-8 ph-all mt-9'>
                <h1 className=' titre text-[#1D2951] text-4xl pht font1 md:text-4xl lg:text-[2.6rem] mt-2 font-extrabold mb-4'>
                    {t('photo.title')}
                </h1>
                <p className=' plf text-gray-700 php  phd  text-xl text-justify lg:text-xl font4 font-light mb-8'>
                    {t('photo.p1')}
                </p>
                <div className='pbtn flex space-x-4'>
                    <RouterLink to="/Galerie"
                        className='plf bg-[#E4BD88] text-[#1D2951] no-underline py-2  px-8 rounded-full text-lg font-medium transition hover:bg-opacity-90'>
                        {t('photo.btn1')}
                    </RouterLink>
                    <a href="#Videos"
                        className='plf bg-[#1D2951] text-[#E4BD88] no-underline py-2 px-8 rounded-full text-lg font-medium transition hover:bg-opacity-90'>
                        {t('photo.btn2')}
                    </a>
                </div>
            </div>

            <div className='flex flex-col items-center w-full max-w-xl md:w-auto mt-10 md:mt-0'>
                <div className='w-full max-w-[510px]'>
                    <button
                        onClick={() => openModal(imagePaths.main)}
                        className="w-full h-auto p-0 border-none cursor-pointer transition duration-200 hover:scale-[1.01] focus:outline-none focus:ring-4 focus:ring-[#D8B273]/50">
                        <img src={imagePaths.main}
                            alt={galleryImages[0].alt}
                            className={`w-full  h-[400px] object-cover ${mainImageClasses}`} />
                    </button>
                </div>

                <div className='flex justify-between w-full max-w-[510px] mt-6 gap-4'>
                    <button onClick={() => openModal(imagePaths.thumb1)} className="image-button transition duration-200 hover:scale-[1.02] focus:outline-none focus:ring-4 focus:ring-[#D8B273]/50">
                        <img src={imagePaths.thumb1}
                            alt={galleryImages[1].alt}
                            className={`w-[156px] h-[186px] object-cover ${thumbnailClasses}`} />
                    </button>
                    <button onClick={() => openModal(imagePaths.thumb2)} className="image-button transition duration-200 hover:scale-[1.02] focus:outline-none focus:ring-4 focus:ring-[#D8B273]/50">
                        <img src={imagePaths.thumb2}
                            alt={galleryImages[2].alt}
                            className={`w-[156px] h-[186px] object-cover ${thumbnailClasses}`} />
                    </button>
                    <button onClick={() => openModal(imagePaths.thumb3)} className="image-button transition duration-200 hover:scale-[1.02] focus:outline-none focus:ring-4 focus:ring-[#D8B273]/50">
                        <img
                            src={imagePaths.thumb3}
                            alt={galleryImages[3].alt}
                            className={`w-[156px] h-[186px] object-cover ${thumbnailClasses}`}/>
                    </button>
                </div>
            </div>

            {isModalOpen && (
                <Portal>
                    <div
                    className="fixed top-0 inset-0 bg-black/70 h-dvh flex justify-center items-center z-[1000]"
                    onClick={closeModal}
                >
                    <div
                        className="   max-w-6xl max-h-[90vh] w-full p-4 "
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            className="absolute top-4 right-4 md:right-10 bg-[#1D2951] text-white rounded-full w-10 h-10 flex justify-center items-center text-2xl cursor-pointer hover:bg-[#E4BD88] transition z-[1001]"
                            onClick={closeModal}
                            aria-label="Close image viewer"
                        >
                            <X size={20} />
                        </button>
                        <img
                            src={selectedImage}
                            alt="Enlarged view"
                            className="max-w-full z-[1000]  max-h-[80vh] object-contain mx-auto rounded-lg shadow-2xl"
                        />
                    </div>
                </div>
                </Portal>
            )}
        </div>
    );
}

export default Photos;